import React from "react"
import "./video.scss"
import axios from 'axios'
import fileDownload from 'js-file-download'

interface VideoProps {
    video: any;
    download?: boolean;
  }

const Videos = (props: VideoProps) => {

   const downloadFile = async (url: string, filename: string) => {
      axios.get(url, {
         responseType: 'blob',
       })
       .then((res) => {
         fileDownload(res.data, filename)
       })
   }

   return (
      <div className="a-video">
         <video className={`a-video__video ${props.download ? "--height": null}`} controls>
            <source src={props.video.file.url} type="video/mp4"></source>
         </video>
         {props.download ?
         <div className="a-video__download">
            <span onClick={() => downloadFile(props.video.file.url, `${props.video.title}.mp4`)} >
               DESCARGAR <i className="icon-download"></i>
            </span>
         </div>

         :
            null
         }
      </div>
   )
}

export default Videos